const env = process.env.NODE_ENV
var baseUrl_online = "http://192.168.2.75:19091";
// var baseUrl_online = "https://train.aojuai.com";
const config = {
  development:{
    // baseURL :url//本地
    baseURL :baseUrl_online, //线上 
  },
  production:{
     baseURL :'https://train.aojuai.com',
    
  }
}
export default {  
  baseURL:config[env].baseURL,
}


// WEBPACK FOOTER //
// ./src/utils/env.js